import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-background border-t border-border mt-auto">
      <div className="max-w-7xl mx-auto px-6 py-6">
        <div className="flex flex-col sm:flex-row items-center justify-between text-sm text-muted-foreground gap-4">
          <div className="flex flex-wrap items-center gap-x-4 gap-y-2 justify-center sm:justify-start">
            <span className="text-foreground/80">© {new Date().getFullYear()} Artis.io - v1.0.0</span>
            <Link to="#" className="hover:text-accent transition-colors">Conditions d'utilisation</Link>
            <Link to="#" className="hover:text-accent transition-colors">Politique de confidentialité</Link>
            <Link to="#" className="hover:text-accent transition-colors">Cookies</Link>
          </div>
          <div className="flex items-center gap-3">
            <span className="hidden sm:inline">Support :</span>
            <a href="mailto:support@artis.io" className="text-accent hover:text-accent/80 transition-colors font-medium">
              support@artis.io
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;